import SendRequest from "../views/SendRequest/SendRequest";

const menu = [
];

const routes = [
  {
    path: "/sendrequest",
    name: "sendrequest",
    component: SendRequest,
    meta: {
      forAuth: true
    }
  }
];

export default { menu, routes };
